<!-- PCIPal -->
<!-- ---------------------------------------------------------------------------------- -->
<!-- #region PCIPal IFRAME -->
<div class="pcipal-container" data-qa="payment-getaway">
  <iframe
    id="pcipal"
    class="pcipal-container__iframe"
    name="pcipal_frame"
    sandbox="allow-scripts allow-same-origin"
  ></iframe>
  <form
    #embedForm
    name="embedForm"
    target="pcipal_frame"
    method="post"
    [action]="iframeActionUrl"
  >
    <input
      type="hidden"
      name="X-BEARER-TOKEN"
      [value]="paymentData.accessToken"
    />
    <input
      type="hidden"
      name="X-REFRESH-TOKEN"
      [value]="paymentData.refreshToken"
    />
  </form>
</div>

<horizon-button
  [text]="'actions.cancel'"
  [type]="'cancel'"
  [isProgressButton]="false"
  (clickEvent)="cancelPayment()"
></horizon-button>
<!-- #endregion -->
